import { render, staticRenderFns } from "./ClientInformationPopup.vue?vue&type=template&id=2bf2954d&scoped=true"
import script from "./ClientInformationPopup.vue?vue&type=script&lang=ts"
export * from "./ClientInformationPopup.vue?vue&type=script&lang=ts"
import style0 from "./ClientInformationPopup.vue?vue&type=style&index=0&id=2bf2954d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2954d",
  null
  
)

export default component.exports